<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="'shared:download-build.msiDownloadInfo.title' | i18next">
  <ng-container modal-body>
    <p>{{ 'shared:download-build.msiDownloadInfo.description' | i18next }}</p>

    <div class="text-sm font-monospace text-break pre-wrap border bg-secondary p-3">{{ command }}</div>
    <mbs-button
      class="d-inline-block mt-2"
      icon="fa fa-clipboard"
      type="secondary"
      (click)="copyCommand()">
      {{ 'shared:buttons.copy' | i18next }}
    </mbs-button>
    <p class="text-sm text-muted mt-2 mb-0">{{ 'shared:download-build.msiDownloadInfo.hint' | i18next }}</p>

    @if ('HelpMarketing' | can: 'read') {
      <a
        class="d-inline-block mt-3"
        rel="noopener noreferrer"
        target="_blank"
        [href]="documentationUrl">
        {{ 'shared:download-build.msiDownloadInfo.documentation' | i18next }}
      </a>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="continue()">
      {{ 'shared:buttons.continue' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="cancel()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
